export default __webpack_public_path__ + "static/media/cross.d25e1fc0.svg";